export default {
    title: '本站居然运行了',
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    pv: '访问量',
    uv: '访客量'
}
